<template>
    <!-- ITDEVELOP-2722: ui/Dialog replaces the scrim div + styled <dialog>.
         Always open while mounted (parents v-if this shell); Esc / outside-click
         emit cancel via the primitive. bg-primary keeps the pre-migration
         surface — it is a semantic token that flips in dark. -->
    <Dialog :open="true" @update:open="(open) => !open && $emit('cancel')">
        <DialogContent
            :data-testid="testId"
            class="bg-primary h-2/3 min-h-96 w-[90%] max-w-none md:w-1/2"
            :aria-describedby="undefined"
        >
            <DialogTitle>{{ title }}</DialogTitle>
            <div class="flex min-h-0 flex-1 flex-col">
                <div class="min-h-0 flex-1 overflow-y-auto">
                    <slot />
                </div>
                <div class="gap-sm mt-auto flex">
                    <slot name="footer">
                        <button class="bold" type="button" @click="$emit('cancel')">Close</button>
                    </slot>
                </div>
            </div>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';

defineProps<{
    title: string;
    testId?: string;
}>();

defineEmits(['cancel']);
</script>
